import React from 'react';
import { Send } from 'lucide-react';
import { v4 as uuidv4 } from 'uuid';
import { useApp, useAuth } from '../../../hooks';
import { useConsumption } from '../../../queries';

function ChatInput({ setMessages, sendStudentMessage }) {
  const { user } = useAuth();
  const { showPlans } = useApp();
  const { isCreditExhauted } = useConsumption();
  const [chatInput, setChatInput] = React.useState('');

  const sendMessage = async (e) => {
    e.preventDefault();
    if (isCreditExhauted) {
      showPlans();
      return;
    }
    const chatId = uuidv4();
    if (chatInput !== '') {
      setMessages((prevState) => [
        ...prevState,
        {
          id: chatId,
          message: chatInput,
          isSentByUser: true,
          photoURL: user?.photoURL,
          displayName: user?.displayName
        }
      ]);
    }
    sendStudentMessage(chatInput);
    setChatInput('');
    setTimeout(() => {
      const ele = document.getElementById(chatId);
      ele?.scrollIntoView({ behavior: 'smooth' });
    }, 0);
  };

  const handleChange = (e) => {
    setChatInput(e.target.value);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-20 border-t border-border/60 bg-white/95 px-2 pb-[calc(0.75rem+env(safe-area-inset-bottom,0px))] pt-3 backdrop-blur-sm md:bottom-3 md:left-1/2 md:w-[min(100%,72rem)] md:-translate-x-1/2 md:rounded-2xl md:border md:px-4 md:pb-3 md:shadow-lg">
      <form
        onSubmit={sendMessage}
        className="flex items-center gap-2 rounded-xl border border-border/60 bg-muted/30 px-4 py-2 focus-within:border-primary/40 focus-within:ring-2 focus-within:ring-ring/20"
      >
        <input
          type="text"
          value={chatInput}
          onChange={handleChange}
          placeholder="Write your response here..."
          className="flex-1 bg-transparent text-sm outline-none placeholder:text-muted-foreground md:text-base"
          aria-label="Chat message"
        />
        <button
          type="submit"
          disabled={!chatInput.trim()}
          aria-label="Send message"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground transition-all hover:bg-primary/90 disabled:opacity-40 active:scale-95"
        >
          <Send className="h-4 w-4" aria-hidden />
        </button>
      </form>
    </div>
  );
}

export default ChatInput;
